import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    name: yup.string().typeError(errors.REQUIRED).required(errors.REQUIRED),
  });
};

export default validation;
